import type { GameId } from '../shared/games';
import type { GameContent } from './types';

import cryptogram from './games/cryptogram.json';
import wordCircle from './games/wordCircle.json';
import wordSearch from './games/wordSearch.json';
import wordLadder from './games/wordLadder.json';
import hashtag from './games/hashtag.json';
import wordBloom from './games/wordBloom.json';
import codeWord from './games/codeWord.json';
import rootwords from './games/rootwords.json';
import wordDominoes from './games/wordDominoes.json';
import emojiAnagram from './games/emojiAnagram.json';
import groupThink from './games/groupThink.json';
import wordChain from './games/wordChain.json';
import numberCrunch from './games/numberCrunch.json';
import topAnswer from './games/topAnswer.json';
import longshot from './games/longshot.json';

/**
 * Evergreen copy for every game that has a page.
 *
 * Imported explicitly rather than through `import.meta.glob` because the
 * build-time prerenderer bundles this module with esbuild, which has no Vite
 * glob. The explicit list also means a missing file is a type error at build
 * time rather than a page that silently renders without its content.
 */
export const GAME_CONTENT = {
  cryptogram,
  wordCircle,
  wordSearch,
  wordLadder,
  hashtag,
  wordBloom,
  codeWord,
  rootwords,
  wordDominoes,
  emojiAnagram,
  groupThink,
  wordChain,
  numberCrunch,
  topAnswer,
  longshot,
} as unknown as Record<GameId, GameContent>;

/** Games with a landing page, in hub order. */
export const CONTENT_GAME_IDS = Object.keys(GAME_CONTENT) as GameId[];

export const gameContent = (id: GameId): GameContent | undefined => GAME_CONTENT[id];
